import "./Navbar.css";
import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

const Navbar = () => {
  const { user, role, userPermissions, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const normalizedRole = role?.toLowerCase();
  const izinler = userPermissions?.kazatakip || {};

  const handleLogout = async () => {
    await logout();
    navigate("/");
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src="/logo.png" alt="logo" className="navbar-logo" />
        <span className="navbar-title">Olay Takip Sistemi</span>
      </div>

      {user && (
        <>
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span></span><span></span><span></span>
          </div>

          <div
            className={`navbar-links ${menuOpen ? "show" : ""}`}
            ref={menuRef}
          >
            {normalizedRole === "oluşturucu" && (
              <NavLink className="navbar-link" to="/kaza-takip/admin" onClick={() => setMenuOpen(false)}>Admin</NavLink>
            )}


            {normalizedRole === "oluşturucu" && (
              <NavLink className="navbar-link" to="/kaza-takip/mail-scheduler" onClick={() => setMenuOpen(false)}>Mail Programlama</NavLink>
            )}

            {izinler?.takip && (
              <NavLink className="navbar-link" to="/kaza-takip/kaza-ekle" onClick={() => setMenuOpen(false)}>Kaza Ekle</NavLink>
            )}
            {izinler?.takip && (
              <NavLink className="navbar-link" to="/kaza-takip/toplu-personel-yukle" onClick={() => setMenuOpen(false)}>Toplu Personel Yükle</NavLink>
            )}
            {izinler?.takip && (
              <NavLink className="navbar-link" to="/kaza-takip/kaza-toplu-yukle" onClick={() => setMenuOpen(false)}>Excelden Yükle</NavLink>
            )}
            {izinler?.giris && (
              <NavLink className="navbar-link" to="/kaza-takip/kazalar-listesi" onClick={() => setMenuOpen(false)}>Kazalar Listesi</NavLink>
            )}
            {izinler?.giris && (
              <NavLink className="navbar-link" to="/kaza-takip/istatistikler" onClick={() => setMenuOpen(false)}>İstatistikler</NavLink>
            )}
            {izinler?.takip && (
              <NavLink className="navbar-link" to="/kaza-takip/personel-yonetim" onClick={() => setMenuOpen(false)}>Personel Yönetim</NavLink>
            )}
            <NavLink className="navbar-link" to="/secilen-proje" onClick={() => setMenuOpen(false)}>🔁 Proje Seç</NavLink>
            <button className="logout-button" onClick={handleLogout}>Çıkış</button>
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar;
